import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './Components/common/Layout';
import { Blog } from './pages/Blog';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
// import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Home } from './pages/Home';
import { ScrollToTop } from './Components/common/ScrollToTop';
import { CookieConsentBanner } from './Components/common/CookieConsentBanner';
import { VisualsRedirect } from './Components/VisualsRedirect';

function AppContent() {
  // Initialize Google Analytics
  // useGoogleAnalytics();

  return (
    <>
      <Routes>
        {/* Home page - without layout wrapper since it has its own navigation */}
        <Route path="/" element={<Home />} />

        <Route path="/visuals" element={<VisualsRedirect />} />
        
        {/* Other pages - with layout wrapper */}
        <Route path="/blog" element={
           <Layout children={<Blog />} />
        } />
        <Route path="/privacy" element={
          <Layout children={<PrivacyPolicy />} />
        } />
        {/* <Route path="/terms-of-service" element={
          <Layout children={<TermsOfService />} />
        } /> */}
        {/* <Route path="/about" element={
          <Layout children={<About />} />
        } /> */}
        <Route path="/contact" element={
          <Layout children={<Contact />} />
        } />
        
        {/* Fallback to home */}
        <Route path="*" element={<Home />} />
      </Routes>
      
      {/* Cookie Consent Banner */}
      <CookieConsentBanner />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}
